<template>
    <all-topics type="mine" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'Mine',
}
</script>
